import { useEffect, useState } from 'react'

export const DEFAULT_INPUT_DEBOUNCE_MS = 500

const useDebounce = <T>(value: T, delay = DEFAULT_INPUT_DEBOUNCE_MS): T => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}

export default useDebounce
